import * as React from 'react';
import { ChromePicker } from 'react-color';
import { CTooltip, CTooltipLabel, CTooltipText } from '/client/src/components/tooltip/';
// import _ from 'lodash';

function useOutsideAlerter(ref, togglePickerCb) {
  React.useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        togglePickerCb(false);
      }
    }

    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);
}

const SelfCheckinColorPicker = (props) => {
  const [isShowColorPicker, togglePicker] = React.useState(false);
  const [inValidColorPickerValue, toggleErrorMsg] = React.useState(false);
  const checkHEX =
    /^#[0-9A-F]{6}$/i.test(props.selectedColor) ||
    /^#([0-9A-F]{3}){1,2}$/i.test(props.selectedColor);
  const wrapperRef = React.useRef(null);

  useOutsideAlerter(wrapperRef, togglePicker);

  return (
    <div
      className="form-group"
      style={{ position: 'relative' }}
      ref={wrapperRef}
    >
      <label>
        Self check-in color theme
        <CTooltip>
          <CTooltipLabel standart>?</CTooltipLabel>
          <CTooltipText>Enter a HEX color code</CTooltipText>
        </CTooltip>
      </label>
      <div className="d-flex" style={{ position: 'relative' }}>
        <input
          className="form-control colorPickerInput"
          value={props.selectedColor}
          name="colorPicker"
          onChange={(e) => {
            props.handleChangeComplete(e.target.value);
            toggleErrorMsg(checkHEX);
          }}
        />
        <span
          className="colorPickerBtn"
          style={{ background: props.selectedColor }}
          onClick={() => togglePicker(!isShowColorPicker)}
          data-show-picker={isShowColorPicker}
        />

        <ChromePicker
          color={props.selectedColor}
          onChangeComplete={(color) => {
            props.handleChangeComplete(color.hex);
          }}
        />
      </div>
      <span className="validationMessage validationMessageColorPicker">
        {inValidColorPickerValue ? 'Invalid HEX color code' : ''}
      </span>
    </div>
  );
};

export default SelfCheckinColorPicker;
